import React, { memo, useState } from 'react';
import useMount from '../../utils/hooks/use-mount';
import { delay } from '../../utils/common-util';

/**
 * 显示 footer, 避免闪烁
 * @returns {JSX.Element}
 * @constructor
 */
const DisplayPublicFooter = () => {
  const [hasMount, setHasMount] = useState(false);
  useMount(() => {
    setHasMount(true);

    delay(1000).then(() => {
      window.init_OMNI__COMMON__FOOTER();
    });

    // console.log(FOOTER_SOURCE_ID);
  });
  if (!hasMount) {
    return null;
  }
  return <div id="OMNI__COMMON__FOOTER" className="OMNI__COMMON__FOOTER" />;
};

export default memo(DisplayPublicFooter);
